export default {
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  networkError: '网络错误，请稍后重试',
  serverError: '服务器错误，请稍后重试',
  timeout: '请求超时，请稍后重试',
  actionSuccess: '操作成功',
  actionFailed: '操作失败',
  addSuccess: '新增成功',
  editSuccess: '编辑成功',
  deleteSuccess: '删除成功',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  confirmDelete: '确定要删除吗？此操作不可恢复',
  product: {
    addSuccess: '产品添加成功',
    editSuccess: '产品编辑成功',
    deleteSuccess: '产品删除成功',
  },
  batch: {
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
  },
  category: {
    actionSuccess: '操作成功',
    actionFailed: '操作失败',
    deleteSuccess: '删除成功',
  },
  attr: {
    actionSuccess: '操作成功',
    actionFailed: '操作失败',
    deleteSuccess: '删除成功',
  },
  gift: {
    actionSuccess: '操作成功',
    actionFailed: '操作失败',
    deleteSuccess: '删除成功',
  },
  giftCategory: {
    actionSuccess: '操作成功',
    actionFailed: '操作失败',
    deleteSuccess: '删除成功',
  },
  factory: {
    actionSuccess: '操作成功',
    actionFailed: '操作失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
  },
};
